export default __webpack_public_path__ + "static/media/Básico1.c06d93fe.jpg";